VP = window.VP || {};

(function ($) {
	VP.dayFiltering = {
        enabled:false,
        filtered:false,
        $dayfilters:null,
        clicktimer:null,
        clickdelay:300,

        selectors: {
            sections:".vp-wrapper.vp-story__item[data-type='article-section']",
            sections_st:".vp-story-tracker__item",
            breakers:".vp-wrapper.vp-story__item[data-type='breaker']",
            breakers_st:".vp-story-tracker__breaker",            
        },
        
		init: function () {
			var _this = this;   
            _this.$dayfilters = $(".dayfilter");
            if (!_this.$dayfilters.length) {
                return;
            }
            
            _this.enabled = true;
            
            _this.$dayfilters.on("mouseover", function() {
                if (!VP.helpers.mousedown) return                            
                _this.itemclick($(this));
            });

            _this.$dayfilters.on("mousedown", function() {                 
                _this.itemclick($(this));
            });

            // all for page to load with items filtered
            var $selected = _this.$dayfilters.filter(".selected");
            if (!$selected.hasClass("all")) {
                _this.filterclick($selected);
            }

            $(".vp-sectioncontainer").append('<div class="vp-wrapper filterempty"><div class="vp-module vp-content-body-module vp-wysiwyg "><div class="vp-content-body-module__details"><p>No events available on selected dates, please change your selection</p></div></div>');
            $(".filterempty").hide();

             // PASS DAYS INTO PARAMS
            
            var dayselect = VP.helpers.getQParams("d") || "";
            var dayarr = dayselect.split("-");

            $.each(dayarr, function(i, v) {  
                if (!v || v.trim() === "") {
                    console.warn("Skipping empty dayletter value:", v);
                    return;
                }
            
                var $dayitem = $("[data-dayletter='" + v + "']");
                if ($dayitem.length) {                    
                    _this.itemclick($dayitem);
                }
            });

		},
        itemclick: function ($btn) {
            var _this = this;

        
            var _isall = $btn.hasClass("all");
            var _tot = $(".dayfilter.selected").length;

            if (_isall) {
                $(".dayfilter.selected").removeClass("selected");
                $btn.addClass("selected");
            }
            else {
                $(".dayfilter.all.selected").removeClass("selected");                    
                if ($btn.hasClass("selected")) {
                    $btn.removeClass("selected");                     
                }
                else {
                    $btn.addClass("selected");
                }
                if ($(".dayfilter.selected").length == 0) {
                    $(".dayfilter.all").addClass("selected");    
                }
            }
            var elabel = $btn.data("dayletter");
            var eaction = $btn.text();
            VP.helpers.firecustomGTMEvent("clickdatefilter",elabel,eaction);
            _this.filteritemsdebounce();
        },

        filteritemsdebounce: function() {
            var _this = this;
            clearTimeout(_this.clicktimer);
            _this.clicktimer = setTimeout(function() {
                _this.filteritems();
            },_this.clickdelay);
        },
		filteritems: function () {
            if ($('.vp-day-carousel-filter').length) {
                return false;
            }

            var _this = this;
            // console.log("[filteritems]");
            $btns = $(".dayfilter.selected");

            var _aselector = "";
            var $inlists = $(_this.selectors.sections + "[data-dayints*=inlist]");
            var $active = $();

            // show all items            
            $(_this.selectors.sections).removeClass("filtermatch").show();
            $(_this.selectors.sections_st).show();
            $(_this.selectors.breakers).show();
            $(_this.selectors.breakers_st).show();                
            $(_this.selectors.sections + "[data-dayints*=inlist]").find("li").show().removeClass("greyed").removeClass("filtermatchli");            


            $btns.each(function () {
                $btn = $(this);
                var _cdate = $btn.data("day");                
                var _cdateletter = $btn.data("dayletter");
                // console.log("[filteritems] SHOWING: " + _cdate + " " + _cdateletter);
                
                // console.log(_cdate);
                if (_cdate == "all") {
                    _this.filtered = false;
                    // console.log("all items shown");
                }
                else {
                    _this.filtered = true;
                    _aselector += _this.selectors.sections + "[data-dayints*="+_cdate+"],"
                
                    $inlists.each(function() {
                        var $thisinlist = $(this);
                        var $lis = $thisinlist.find("li");
                        $lis.each(function() {
                            var $liitem = $(this);
                            // if already matched, skip it
                            if (!$liitem.hasClass("filtermatchli")) { 
                                if ($liitem.hasClass(_cdateletter) || $liitem.hasClass("all") ) {
                                    $liitem.show().removeClass("greyed").addClass("filtermatchli");
                                    $active = $active.add($thisinlist);      
                                    // console.log("[filteritems] ADD INLIST", $thisinlist,$liitem);
                                }
                                else {
                                    //$(this).hide(); // instead of hiding, just grey it out
                                    $liitem.addClass("greyed");
                                }
                            }
                        });
                    });
                }
                
            })

            if (_this.filtered) {

                // show active days + all days   
                _aselector += _this.selectors.sections + "[data-dayints*=alldays]";

                var $activeitems =$(_aselector);
                $active = $active.add($activeitems);
        
                $(_this.selectors.sections).removeClass("filtermatch").hide();
                $(_this.selectors.sections_st).hide();

                
                $active.addClass("filtermatch").show();
            }

            _this.setfilters();
		},

        setfilters: function() {
            var _this = this; 
            
            $("body").find(".js-reveal:not(.js-reveal--visible)").addClass("js-reveal--visible"); 
            // just show everything, reveal gets all wonky // TODO: still something wrong with Newsletter showing

            $(".filtermatch").each(function() {                    
                var _itemno = $(this).data("value");
                var $stsection = $(_this.selectors.sections_st + "[data-item-no="+_itemno+"]");
                $stsection.show();    
            });

            // if active filter, show only breakers that have article sections after it
            $(_this.selectors.breakers).each(function(i) {   
                var $thisbreaker = $(this);                 
                var $next = $thisbreaker.nextAll(":visible").first();
                
                var _bid = parseInt($thisbreaker.data("breakerid"));
                var $stbreaker = $(_this.selectors.breakers_st + ":eq("+_bid+")");
                if ($next.length && ($next.data("type") =="article-section")) {
                    $thisbreaker.show();
                    $thisbreaker.find(".js-reveal").addClass("js-reveal--visible");                                                                         
                    $stbreaker.show();                          
                }
                else {
                    $thisbreaker.hide();
                    $stbreaker.hide();                        
                }
            })                
            
          //  VP.storyTracker.update();  // triggers focus map markers

            // TODO: ? focus on map marker for first selected
            var $firstvis = $(_this.selectors.sections_st).filter(":visible").first();
            if ($firstvis.length) {                
                var _itemNo = $firstvis.data( "item-no" ) - 1;
                VP.storyTracker.focusMapMarker( _itemNo );
            }

            if (_this.filtered) {
                $("body").addClass("isfiltered");
            }
            else {
                $("body").removeClass("isfiltered");
            }

            if ($(_this.selectors.sections).filter(":visible").length == 0) {
                $(".filterempty").show();
            }
            else {
                $(".filterempty").hide();
            }
        }
		
	};
})(jQuery);
